import pluralize from 'cio/utils/pluralize';
import { TIMEFRAME_UNITS } from 'cio/utils/round-timeframe-units';

export class TimeframeUnit<T, K extends keyof T> {
  context: T;
  value: string;
  countProperty?: K;

  constructor({ context, value, countProperty }: { context: T; countProperty?: K; value: string }) {
    this.context = context;

    this.value = value;
    this.countProperty = countProperty;
  }

  get label() {
    let { context, countProperty, value } = this;
    let contextCount = countProperty !== undefined && context[countProperty];

    if (typeof contextCount !== 'number') {
      return pluralize(0, value);
    }

    return pluralize(contextCount, value);
  }
}

/*
 * Returns array of time units, with computed label, with plurality based on passed context timeframe count property value
 * Used to generate time unit dropdown options
 */
export default function timeframeUnits<T, K extends keyof T>({
  context,
  countProperty,
  units = TIMEFRAME_UNITS,
}: {
  context: T;
  countProperty?: K;
  units?: { value: string; seconds: number }[];
}) {
  return units.map(({ value }) => new TimeframeUnit<T, K>({ context, value, countProperty }));
}
